import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { FALLBACK_IMAGE_MD, LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { ReserveGallerySingle } from "@website/widget/reserve-gallery-detail/reserve-gallery-single";
import { ReserveGalleryDetailContainer } from "@website/widget/reserve-gallery/reserve-gallery-detail-container";
import { useReserveGallery } from "@website/widget/reserve-gallery/reserve-gallery.hook";
import { ReserveGalleryPropertiesTypes } from "@website/widget/reserve-gallery/reserve-gallery.types";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = (properties: ReserveGalleryPropertiesTypes) => {
  const router = useRouter();

  const { gallery } = properties;
  const { imagesProps, detailProps, singleProps, moreProps } =
    useReserveGallery(properties);

  if (!gallery?.length) return null;

  return (
    <>
      <div
        className="relative grid grid-cols-1 grid-rows-1 gap-2 overflow-hidden md:h-[360px] md:w-full md:grid-cols-4 md:grid-rows-2 md:rounded-xl xl:h-[400px]"
        id="hotel_gallery"
      >
        {imagesProps?.map(({ imageProps, containerProps }, index) => (
          <div
            itemScope
            {...containerProps}
            className={`${containerProps.className} hidden first:block md:block`}
            key={containerProps?.key}
          >
            <LazyImage
              {...imageProps}
              className="bg-outline-thin h-[200px] w-full object-cover md:h-full"
              fallback={FALLBACK_IMAGE_MD.src}
              loading={index === 0 ? "eager" : "lazy"}
            />
          </div>
        ))}
        {gallery?.length > 5 && (
          <Button
            StartIcon={<MaterialIcon name="apps" />}
            className="!absolute bottom-4 end-4 flex"
            {...moreProps}
          >
            {`${numberConvert(gallery.length, {
              locale: router.locale
            })} تصویر در گالری`}
          </Button>
        )}
      </div>
      <ReserveGalleryDetailContainer {...detailProps} />
      <ReserveGallerySingle {...singleProps} />
    </>
  );
};
export const ReserveGallery = memo(Component, deepCompare);
